(function () {
    'use strict';

    angular.module("imApp").factory("textileModelCategory6sService", ['$ihttp', function ($ihttp) {
        let service = {
            listTextileModelCategory6s: function (parms) {
                return $ihttp.post({
                    method: 2691,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
